<template>
  <div class="manage-modal">
    <HeaderModal
      :header-text="
        getComponentUiText(
          'app-component-search-box-assessment-search-button-1',
        )
      "
      class="!tw-px-[20px] md:!tw-px-[40px]"
      @close-modal="closeModal"
    />
  </div>
  <div class="search-modal-contain tw-flex tw-flex-col tw-gap-y-[20px]">
    <div
      class="tw-flex tw-flex-wrap md:tw-items-center tw-w-full tw-justify-between tw-items-center tw-gap-y-[15px]"
    >
      <slot name="searchFilter" />
      <div
        class="tw-flex tw-flex-wrap md:tw-items-center md:tw-justify-end tw-gap-y-[15px]"
      >
        <ButtonBulkActions
          :active="seletedAssessmentRow?.length > 0"
          :is-margin-right="false"
          :selected-number="seletedAssessmentRow?.length"
        />

        <div class="filter-action">
          <ButtonFilter
            :active="fiterTargetOption.length > 0"
            :is-filter="
              originSelected.filter((item) => !item.value.isDefault).length > 0
            "
            :show-more-actions="isShowFilterAction"
            :id-popover="'popoverBtnFilterMainAssessmentSearch'"
            :is-margin-right="false"
            button-class="!tw-h-[46px] tw-ml-5"
            @click-away="outsideFilterModal = true"
            @click="handleShowFilterAction"
          >
            <FilterModal
              :targets="fiterTargetOption"
              :is-date="false"
              :is-search="false"
              :show-more-actions="isShowFilterAction"
              :filter-selected="filterSelected"
              :outside-filter-modal="outsideFilterModal"
              :original-data="{
                filterSelected: cloneDeep(originSelected),
              }"
              @update:apply-filter="handleApplyFilter"
            />
          </ButtonFilter>
        </div>
        <!--
 <div v-if="isHavePermisstionShowMaster" class="tw-flex tw-gap-[15px]">
          <AssessmentToggleSwitch
            :title="
              getComponentUiText('app-component-assessment-toggle-switch-2')
            "
            :is-checked="isMasterItems"
            class-name="tw-mb-0"
            @update:checked="onUpdateShowMasterItem"
          />
        </div> 
-->
      </div>
    </div>
    <slot name="listFilter" />
  </div>
</template>

<script setup lang="ts">
import HeaderModal from "@/components/common/headerModal.vue";
import { checkIsHavePermisstion, getComponentUiText } from "@/utils/utilities";
import ButtonBulkActions from "../common/setting/buttonBulkActions.vue";
import ButtonFilter from "@/components/common/setting/buttonFilter.vue";
import FilterModal from "@/components/common/filter/filterModal.vue";
import { computed, ComputedRef, onMounted, ref, Ref, watch } from "vue";
import store from "@/store";
import { useRoute } from "vue-router";
import { IFilterSelect, IFilterTarget } from "@/interfaces/common/common";
import cloneDeep from "lodash/cloneDeep";

const props = defineProps({
  seletedAssessmentRow: {
    type: Array,
    default: () => [],
  },
  originSelected: {
    type: Array as () => IFilterSelect[],
    default: () => [],
  },
  filterSelected: {
    type: Array as () => IFilterSelect[],
    default: () => [],
  },
  onInputModalFocus: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits([
  "closeModal",
  "update:loading",
  "update:apply-filter",
  "clickOutside",
  "update:show-filter-modal",
]);
const isHavePermisstionShowMaster: Ref<boolean | undefined> = ref(false);
const checklistIdParam = ref<number>(0);
const route = useRoute();
const outsideFilterModal = ref(false);

const closeModal = () => {
  isShowFilterAction.value = false;
  emit("closeModal");
};

onMounted(async () => {
  checklistIdParam.value = Number(route.query.checklistId);
  isHavePermisstionShowMaster.value = await checkIsHavePermisstion(
    "assess_input__show_master_items",
  );
});

const onUpdateShowMasterItem = (value: boolean) => {
  emit("update:loading", true);

  store.dispatch("Assessment/updateShowMasterItems", value);

  const params = {
    checklistIdParam: checklistIdParam.value,
    showMasterItem: value,
  };
  store.dispatch("Assessment/fetchChecklistByCategory", params);
  emit("update:loading", false);
};
const progressCategories = computed(() => store.state.Assessment.categories);

//#region Filter
const fiterTargetOption: ComputedRef<IFilterTarget[]> = computed(() => [
  {
    targetId: "itemCompleteValue",
    targetText:
      "app-component-assessment-display-options-filter-hide-complete-1",
    values: [
      {
        id: 0,
        text: getComponentUiText(
          "app-component-assessment-display-options-filter-hide-complete-option-A-1",
        ),
        isHardText: true,
      },
      {
        id: 1,
        isDefault: true,
        text: getComponentUiText(
          "app-component-assessment-display-options-filter-hide-complete-option-B-1",
        ),
        isHardText: true,
      },
    ],
    isRadio: true,
  },
  {
    targetId: "visibleState",
    targetText:
      "app-component-assessment-display-options-filter-show-excluded-1",
    values: [
      {
        id: 1,
        text: getComponentUiText(
          "app-component-assessment-display-options-filter-show-excluded-option-B-1",
        ),
        isHardText: true,
      },
      {
        id: 0,
        text: getComponentUiText(
          "app-component-assessment-display-options-filter-show-excluded-option-A-1",
        ),
        isHardText: true,
      },
    ],
    isRadio: true,
  },
  {
    targetId: "checklistItemCategoryId",
    targetText:
      "app-component-assessment-display-options-filter-show-category-1",
    values: progressCategories.value.map((category) => ({
      id: category.checklistItemCategoryId,
      text: category.checklistItemCategoryLabel,
      isDefault: false,
      isHardText: true,
    })),
    isRadio: true,
  },
  {
    targetId: "score-increase",
    order: 4,
    targetText:
      "app-component-assessment-display-options-filter-score-increase-1",
    values: [
      {
        id: 1,
        text: getComponentUiText(
          "app-component-assessment-display-options-filter-compliance-percentage-option-above-1",
        ),
        isHardText: true,
        type: "input",
        hindText: "",
      },
      {
        id: 0,
        text: getComponentUiText(
          "app-component-assessment-display-options-filter-compliance-percentage-option-below-1",
        ),
        isHardText: true,
        type: "input",
        hindText: "",
      },
    ],
    isRadio: false,
    isNotClear: true,
  },
  {
    targetId: "itemCompleteValue-percentage",
    order: 4,
    targetText:
      "app-component-assessment-display-options-filter-compliance-percentage-1",
    values: [
      {
        id: 1,
        text: getComponentUiText(
          "app-component-assessment-display-options-filter-compliance-percentage-option-above-1",
        ),
        isHardText: true,
        hindText: "%",
        type: "input",
      },
      {
        id: 0,
        text: getComponentUiText(
          "app-component-assessment-display-options-filter-compliance-percentage-option-below-1",
        ),
        isHardText: true,
        hindText: "%",
        type: "input",
      },
    ],
    isRadio: false,
    isNotClear: true,
  },
]);

const isShowFilterAction = ref(false);
const handleShowFilterAction = () => {
  if (isShowFilterAction.value) {
    outsideFilterModal.value = true;
  } else {
    isShowFilterAction.value = !isShowFilterAction.value;
    emit("update:show-filter-modal", isShowFilterAction.value);
  }
};
watch(
  () => props.onInputModalFocus,
  (newValue) => {
    if (props.onInputModalFocus) {
      isShowFilterAction.value = false;
    }
  },
  { immediate: true },
);
const handleApplyFilter = (data: any) => {
  outsideFilterModal.value = false;
  isShowFilterAction.value = false;
  emit("update:apply-filter", data);
};
//#endregion Filter
</script>

<style scoped lang="scss">
.manage-modal {
  border-bottom: 1px solid var(--ui-rule, #eff0f1);
}
.search-modal-contain {
  background: var(--brand-paper, #eeeff0);
  box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.05);
  padding: 60px;
  @media (max-width: 767px) {
    padding: 20px;
    max-height: calc(100vh - 300px);
  }
}
</style>
